import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Space, Tag } from 'antd';
import { YoutubeOutlined, LinkOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import api from '../utils/api';

// Shown at the top of every page to selected staff (and admins): songs that were
// uploaded to a YouTube channel in the last 7 days. The backend only returns rows
// to admins and to staff who were added to the notify list.
export default function VideoTrackerBanner() {
  const [items, setItems] = useState([]);

  const fetchFeed = useCallback(async () => {
    try {
      const res = await api.get('/video-tracker/feed');
      setItems(res.data || []);
    } catch (err) { /* table may not exist / no access */ }
  }, []);

  useEffect(() => { fetchFeed(); }, [fetchFeed]);

  if (items.length === 0) return null;

  return (
    <Alert
      type="success"
      showIcon
      icon={<YoutubeOutlined />}
      style={{ marginBottom: 16, borderRadius: 10 }}
      message={<b>Naye Songs Upload Hue (last 7 days) — {items.length}</b>}
      description={
        <Space direction="vertical" style={{ width: '100%' }}>
          {items.map(it => (
            <div key={it.id} style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <span style={{ fontWeight: 600 }}>{it.song_title}</span>
              {it.channel_name && <Tag color="red">{it.channel_name}</Tag>}
              {it.uploaded_at && <Tag color="blue">{dayjs(it.uploaded_at).format('DD MMM')}</Tag>}
              {it.youtube_link && (
                <a href={it.youtube_link} target="_blank" rel="noreferrer"><LinkOutlined /> Open</a>
              )}
            </div>
          ))}
        </Space>
      }
    />
  );
}
